import React from 'react';

import { SimpleButton } from '@/src/ui';
import type { QtiQuestionDTO } from '@/src/lib';

interface DebuggerProps {
    question: QtiQuestionDTO;
    errors: any;
}

const Debugger: React.FC<DebuggerProps> = (props) => {
    const { question, errors } = props;

    const handleCopy = () => {
        navigator.clipboard.writeText(JSON.stringify(question, null, 2));
        alert('Question data copied to the clipboard.');
    };

    return (
        <div>
            <div className="mt-8" />
            <SimpleButton variant="contained" color="secondary" onClick={handleCopy}>
                Get Question Data
            </SimpleButton>
            <div className="mt-4" />
            <div className="text-purple-600">
                {errors && Object.keys(errors).length
                    ? `Errors: ${JSON.stringify(errors)}`
                    : 'No errors'}
            </div>
        </div>
    );
};

export default Debugger;
